// extracted by mini-css-extract-plugin
module.exports = {"containerInner":"LandingInfo_containerInner__3YDsC","description":"LandingInfo_description__35ZXd"};